import {cardsPerSet, rentValue} from '@kapitalist/contract/ruleset'
import type {
  TStandardPortfolioNeighborhoodData,
  TStandardPropertyCard,
} from '@kapitalist/contract/types'
import type {TMillions} from '@kapitalist/contract/types/millions'
import {MillionsMath} from '@kapitalist/contract/utils/millions/math'
import ResidenceCard from '~/models/game/Cards/ResidenceCard'
import PortfolioNeighborhood from '~/models/game/PortfolioNeighborhood'

// Represents one grouping of properties on the table in front of each player
// except "alone" wildcards - those are in a separate class because they don't have residences
export default class StandardPortfolioNeighborhood extends PortfolioNeighborhood {
  // protected raw: TStandardPortfolioNeighborhoodData
  public residences: ResidenceCard[]
  public neighborhood: TStandardPropertyCard

  constructor(data: TStandardPortfolioNeighborhoodData) {
    super(data)
    // this.raw = data
    this.neighborhood = data.neighborhood
    this.residences = data.residences.map(r => new ResidenceCard(r))
  }

  isCompleteSet(): boolean {
    return this.properties.length >= cardsPerSet[this.neighborhood]
  }

  isStandardPortfolioNeighborhood(): this is StandardPortfolioNeighborhood {
    return true
  }

  rent(): TMillions {
    return MillionsMath.sum(
      rentValue(this.neighborhood, this.properties.length),
      ...this.residences.map(r => r.additionalRentValue())
    )
  }
}
